// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── CSS Variables for port colours (sourced from design-system.css) ─── */
/* Legacy :root block removed — variables now live in design-system.css */

/* ─── Overlay ─── */
.port-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--modal-overlay);
  backdrop-filter: blur(4px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* ─── Modal container ─── */
.port-modal {
  background: var(--bg-surface);
  border-radius: 16px;
  width: 100%;
  max-width: 940px;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-lg);
}

/* ─── Header ─── */
.port-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-toolbar);
  flex-shrink: 0;
}

.port-modal-title {
  display: flex;
  align-items: center;
  gap: 14px;
}

.port-modal-icon {
  font-size: 30px;
  line-height: 1;
}

.port-modal-title h2 {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 2px;
}

.port-modal-title p {
  font-size: 13px;
  color: var(--text-secondary);
  margin: 0;
}

.port-modal-close {
  background: none;
  border: 1px solid var(--slate-300);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  cursor: pointer;
  font-size: 16px;
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  flex-shrink: 0;
}

.port-modal-close:hover {
  background: var(--error-bg);
  border-color: var(--error-bd);
  color: var(--error-text);
}

/* ─── Stats bar ─── */
.port-modal-stats {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px 24px;
  border-bottom: 1px solid var(--border);
  background: var(--bg-card);
  flex-shrink: 0;
  flex-wrap: wrap;
}

.port-stat {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: var(--text-secondary);
}

.port-stat--right {
  margin-left: auto;
  gap: 16px;
}

.port-stat strong {
  color: var(--text-primary);
  font-size: 15px;
}

.port-stat-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0;
}

.port-legend {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: var(--text-secondary);
}

.port-legend span {
  width: 13px;
  height: 13px;
  border-radius: 3px;
  display: inline-block;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

/* ─── Body ─── */
.port-modal-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ─── Port grid section ─── */
.port-grid-section {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 16px 20px;
}

.port-grid-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.port-grid-hint {
  font-weight: 400;
  color: var(--text-muted);
}

.port-grid-loading,
.port-grid-empty {
  text-align: center;
  color: var(--text-muted);
  padding: 32px;
  font-size: 14px;
}

.port-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.port-row {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

/* ─── Port button ─── */
.port-btn {
  width: 46px;
  height: 46px;
  border: 2px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.12s, box-shadow 0.12s;
  position: relative;
  padding: 2px;
  gap: 1px;
}

.port-btn:hover {
  transform: scale(1.12);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
  z-index: 1;
}

.port-btn--selected {
  border-color: var(--accent) !important;
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.25) !important;
  transform: scale(1.1);
  z-index: 2;
}

.port-num {
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.port-dest-abbr {
  font-size: 8px;
  line-height: 1;
  max-width: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  opacity: 0.85;
}

.port-connector-badge {
  font-size: 6px;
  font-weight: 700;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 2px;
  letter-spacing: 0.03em;
  max-width: 40px;
  white-space: nowrap;
}

/* VLAN del puerto (access NNN / trunk …) — resumen compacto en la casilla.
   El detalle completo ("access 120", "trunk 110,120,130,150") está en el tooltip. */
.port-vlan {
  position: absolute;
  bottom: 1px;
  left: 1px;
  font-size: 6px;
  font-weight: 700;
  line-height: 1;
  padding: 1px 3px;
  border-radius: 3px;
  background: var(--port-vlan-bg, #0284c7);
  color: var(--port-vlan-fg, #ffffff);
  letter-spacing: 0.02em;
  pointer-events: none;
}

.port-vlan--trunk {
  background: var(--port-vlan-trunk-bg, #7c3aed);
}

/* ─── Port editor panel ─── */
.port-editor {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.port-editor-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border);
  font-size: 14px;
  color: var(--text-primary);
  flex-wrap: wrap;
}

.port-editor-num strong {
  font-size: 16px;
}

.port-editor-label {
  color: var(--text-secondary);
}

.port-editor-badge {
  margin-left: auto;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.badge--connected {
  background: var(--badge-on-bg);
  color: var(--badge-on-fg);
}

.badge--free {
  background: var(--bg-toolbar);
  color: var(--text-secondary);
}

/* ─── Field helpers ─── */
.port-field {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.port-field label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.port-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* ─── Destination toggle ─── */
.port-dest-toggle {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.port-toggle-btn {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 13px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.15s;
  white-space: nowrap;
}

.port-toggle-btn.active {
  background: var(--accent);
  border-color: var(--accent);
  color: #fff;
  font-weight: 600;
}

.port-toggle-btn:hover:not(.active) {
  background: var(--slate-200);
}

/* ─── Inputs ─── */
.port-input {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-input);
  transition: border-color 0.15s, box-shadow 0.15s;
  width: 100%;
  box-sizing: border-box;
}

.port-input:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);
}

.port-select {
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 9px 12px;
  font-size: 14px;
  color: var(--text-primary);
  background: var(--bg-input);
  cursor: pointer;
  width: 100%;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.port-select:focus {
  outline: none;
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);
}

/* Títulos de grupo del desplegable nativo. <optgroup> se pinta con fondo
   blanco en Windows/Edge y rompía el tema oscuro; se usan options disabled. */
.port-select option.port-select-group {
  background: var(--bg-surface);
  color: var(--text-secondary);
  font-weight: 600;
}

.port-select option:disabled:not(.port-select-group) {
  color: var(--text-muted);
}

/* Filtro de alcance del selector de destinos. */
.port-scope-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 8px;
  font-size: 0.8125rem;
  color: var(--text-secondary);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.port-scope-toggle input {
  accent-color: var(--accent);
  cursor: pointer;
}

.port-scope-toggle em {
  margin-left: auto;
  font-style: normal;
  color: var(--text-muted);
}

/* ─── Error + Actions ─── */
.port-error {
  background: var(--error-bg);
  border: 1px solid var(--error-bd);
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 13px;
  color: var(--error-text);
}

.port-editor-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

.port-save-btn {
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.port-save-btn:hover:not(:disabled) {
  background: var(--accent-dark);
}

.port-save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ─── Responsive ─── */
@media (max-width: 600px) {
  .port-fields-grid {
    grid-template-columns: 1fr;
  }
  .port-stat--right {
    display: none;
  }
  .port-btn {
    width: 38px;
    height: 38px;
  }
}

/* ─── Connection info banner ─── */

.port-conn-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--conn-banner-bg);
  border: 1px solid var(--conn-banner-bd);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 12px;
  gap: 10px;
  flex-wrap: wrap;
}

.port-conn-path {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  flex: 1 1;
  min-width: 0;
}

.port-conn-arrow {
  color: var(--conn-arrow);
  font-size: 1rem;
  flex-shrink: 0;
}

.port-conn-cable {
  color: var(--text-secondary);
  font-size: 0.8125rem;
  font-family: monospace;
}

.port-conn-color {
  font-size: 0.8125rem;
  color: var(--text-muted);
}

.port-disconnect-btn {
  background: var(--bg-card);
  color: var(--error-text);
  border: 1px solid var(--error-bd);
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8125rem;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.12s;
}

.port-disconnect-btn:hover:not(:disabled) {
  background: var(--error-bg);
}

.port-disconnect-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Hint text in selectors */
.port-loading-hint {
  font-size: 0.8125rem;
  color: var(--text-muted);
  font-style: italic;
}

.port-empty-hint {
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin: 4px 0 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/PortMapModal.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E,yEAAyE;;AAEzE,oBAAoB;AACpB;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8BAA8B;AAC9B;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,sCAAsC;EACtC,8DAA8D;EAC9D,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;AACrB;;AAEA;oFACoF;AACpF;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;AAChD;;AAEA,8BAA8B;AAC9B;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,sCAAsC;EACtC,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,gDAAgD;EAChD,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;8EAC8E;AAC9E;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,mCAAmC;;AAEnC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ─── CSS Variables for port colours (sourced from design-system.css) ─── */\r\n/* Legacy :root block removed — variables now live in design-system.css */\r\n\r\n/* ─── Overlay ─── */\r\n.port-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: var(--modal-overlay);\r\n  backdrop-filter: blur(4px);\r\n  z-index: 1000;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n}\r\n\r\n/* ─── Modal container ─── */\r\n.port-modal {\r\n  background: var(--bg-surface);\r\n  border-radius: 16px;\r\n  width: 100%;\r\n  max-width: 940px;\r\n  max-height: 90vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: var(--shadow-lg);\r\n}\r\n\r\n/* ─── Header ─── */\r\n.port-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 18px 24px;\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  flex-shrink: 0;\r\n}\r\n\r\n.port-modal-title {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n}\r\n\r\n.port-modal-icon {\r\n  font-size: 30px;\r\n  line-height: 1;\r\n}\r\n\r\n.port-modal-title h2 {\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n  margin: 0 0 2px;\r\n}\r\n\r\n.port-modal-title p {\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n}\r\n\r\n.port-modal-close {\r\n  background: none;\r\n  border: 1px solid var(--slate-300);\r\n  border-radius: 8px;\r\n  width: 36px;\r\n  height: 36px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  color: var(--text-secondary);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.15s;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.port-modal-close:hover {\r\n  background: var(--error-bg);\r\n  border-color: var(--error-bd);\r\n  color: var(--error-text);\r\n}\r\n\r\n/* ─── Stats bar ─── */\r\n.port-modal-stats {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 20px;\r\n  padding: 10px 24px;\r\n  border-bottom: 1px solid var(--border);\r\n  background: var(--bg-card);\r\n  flex-shrink: 0;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.port-stat {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  font-size: 13px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.port-stat--right {\r\n  margin-left: auto;\r\n  gap: 16px;\r\n}\r\n\r\n.port-stat strong {\r\n  color: var(--text-primary);\r\n  font-size: 15px;\r\n}\r\n\r\n.port-stat-dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.port-legend {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  font-size: 12px;\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.port-legend span {\r\n  width: 13px;\r\n  height: 13px;\r\n  border-radius: 3px;\r\n  display: inline-block;\r\n  border: 1px solid rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* ─── Body ─── */\r\n.port-modal-body {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n/* ─── Port grid section ─── */\r\n.port-grid-section {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 16px 20px;\r\n}\r\n\r\n.port-grid-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 16px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.port-grid-hint {\r\n  font-weight: 400;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.port-grid-loading,\r\n.port-grid-empty {\r\n  text-align: center;\r\n  color: var(--text-muted);\r\n  padding: 32px;\r\n  font-size: 14px;\r\n}\r\n\r\n.port-grid {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n}\r\n\r\n.port-row {\r\n  display: flex;\r\n  gap: 5px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n/* ─── Port button ─── */\r\n.port-btn {\r\n  width: 46px;\r\n  height: 46px;\r\n  border: 2px solid rgba(0, 0, 0, 0.08);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: transform 0.12s, box-shadow 0.12s;\r\n  position: relative;\r\n  padding: 2px;\r\n  gap: 1px;\r\n}\r\n\r\n.port-btn:hover {\r\n  transform: scale(1.12);\r\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);\r\n  z-index: 1;\r\n}\r\n\r\n.port-btn--selected {\r\n  border-color: var(--accent) !important;\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.25) !important;\r\n  transform: scale(1.1);\r\n  z-index: 2;\r\n}\r\n\r\n.port-num {\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n}\r\n\r\n.port-dest-abbr {\r\n  font-size: 8px;\r\n  line-height: 1;\r\n  max-width: 40px;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  opacity: 0.85;\r\n}\r\n\r\n.port-connector-badge {\r\n  font-size: 6px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  padding: 1px 3px;\r\n  border-radius: 2px;\r\n  letter-spacing: 0.03em;\r\n  max-width: 40px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* VLAN del puerto (access NNN / trunk …) — resumen compacto en la casilla.\r\n   El detalle completo (\"access 120\", \"trunk 110,120,130,150\") está en el tooltip. */\r\n.port-vlan {\r\n  position: absolute;\r\n  bottom: 1px;\r\n  left: 1px;\r\n  font-size: 6px;\r\n  font-weight: 700;\r\n  line-height: 1;\r\n  padding: 1px 3px;\r\n  border-radius: 3px;\r\n  background: var(--port-vlan-bg, #0284c7);\r\n  color: var(--port-vlan-fg, #ffffff);\r\n  letter-spacing: 0.02em;\r\n  pointer-events: none;\r\n}\r\n\r\n.port-vlan--trunk {\r\n  background: var(--port-vlan-trunk-bg, #7c3aed);\r\n}\r\n\r\n/* ─── Port editor panel ─── */\r\n.port-editor {\r\n  background: var(--bg-card);\r\n  border: 1px solid var(--border);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n}\r\n\r\n.port-editor-header {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 1px solid var(--border);\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.port-editor-num strong {\r\n  font-size: 16px;\r\n}\r\n\r\n.port-editor-label {\r\n  color: var(--text-secondary);\r\n}\r\n\r\n.port-editor-badge {\r\n  margin-left: auto;\r\n  padding: 3px 10px;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.badge--connected {\r\n  background: var(--badge-on-bg);\r\n  color: var(--badge-on-fg);\r\n}\r\n\r\n.badge--free {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n}\r\n\r\n/* ─── Field helpers ─── */\r\n.port-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n}\r\n\r\n.port-field label {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  color: var(--text-muted);\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n}\r\n\r\n.port-fields-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 12px;\r\n}\r\n\r\n/* ─── Destination toggle ─── */\r\n.port-dest-toggle {\r\n  display: flex;\r\n  gap: 8px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.port-toggle-btn {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 7px 14px;\r\n  font-size: 13px;\r\n  cursor: pointer;\r\n  color: var(--text-secondary);\r\n  transition: all 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.port-toggle-btn.active {\r\n  background: var(--accent);\r\n  border-color: var(--accent);\r\n  color: #fff;\r\n  font-weight: 600;\r\n}\r\n\r\n.port-toggle-btn:hover:not(.active) {\r\n  background: var(--slate-200);\r\n}\r\n\r\n/* ─── Inputs ─── */\r\n.port-input {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 9px 12px;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.port-input:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n.port-select {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  padding: 9px 12px;\r\n  font-size: 14px;\r\n  color: var(--text-primary);\r\n  background: var(--bg-input);\r\n  cursor: pointer;\r\n  width: 100%;\r\n  transition: border-color 0.15s, box-shadow 0.15s;\r\n}\r\n\r\n.port-select:focus {\r\n  outline: none;\r\n  border-color: var(--accent);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb), 0.1);\r\n}\r\n\r\n/* Títulos de grupo del desplegable nativo. <optgroup> se pinta con fondo\r\n   blanco en Windows/Edge y rompía el tema oscuro; se usan options disabled. */\r\n.port-select option.port-select-group {\r\n  background: var(--bg-surface);\r\n  color: var(--text-secondary);\r\n  font-weight: 600;\r\n}\r\n\r\n.port-select option:disabled:not(.port-select-group) {\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* Filtro de alcance del selector de destinos. */\r\n.port-scope-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  margin: 4px 0 8px;\r\n  font-size: 0.8125rem;\r\n  color: var(--text-secondary);\r\n  cursor: pointer;\r\n  user-select: none;\r\n}\r\n\r\n.port-scope-toggle input {\r\n  accent-color: var(--accent);\r\n  cursor: pointer;\r\n}\r\n\r\n.port-scope-toggle em {\r\n  margin-left: auto;\r\n  font-style: normal;\r\n  color: var(--text-muted);\r\n}\r\n\r\n/* ─── Error + Actions ─── */\r\n.port-error {\r\n  background: var(--error-bg);\r\n  border: 1px solid var(--error-bd);\r\n  border-radius: 8px;\r\n  padding: 9px 14px;\r\n  font-size: 13px;\r\n  color: var(--error-text);\r\n}\r\n\r\n.port-editor-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  padding-top: 8px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.port-save-btn {\r\n  background: var(--accent);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 10px 24px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.port-save-btn:hover:not(:disabled) {\r\n  background: var(--accent-dark);\r\n}\r\n\r\n.port-save-btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* ─── Responsive ─── */\r\n@media (max-width: 600px) {\r\n  .port-fields-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n  .port-stat--right {\r\n    display: none;\r\n  }\r\n  .port-btn {\r\n    width: 38px;\r\n    height: 38px;\r\n  }\r\n}\r\n\r\n/* ─── Connection info banner ─── */\r\n\r\n.port-conn-info {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: var(--conn-banner-bg);\r\n  border: 1px solid var(--conn-banner-bd);\r\n  border-radius: 8px;\r\n  padding: 10px 12px;\r\n  margin-bottom: 12px;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.port-conn-path {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 0.875rem;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.port-conn-arrow {\r\n  color: var(--conn-arrow);\r\n  font-size: 1rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.port-conn-cable {\r\n  color: var(--text-secondary);\r\n  font-size: 0.8125rem;\r\n  font-family: monospace;\r\n}\r\n\r\n.port-conn-color {\r\n  font-size: 0.8125rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.port-disconnect-btn {\r\n  background: var(--bg-card);\r\n  color: var(--error-text);\r\n  border: 1px solid var(--error-bd);\r\n  border-radius: 6px;\r\n  padding: 5px 10px;\r\n  font-size: 0.8125rem;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n  flex-shrink: 0;\r\n  transition: background 0.12s;\r\n}\r\n\r\n.port-disconnect-btn:hover:not(:disabled) {\r\n  background: var(--error-bg);\r\n}\r\n\r\n.port-disconnect-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Hint text in selectors */\r\n.port-loading-hint {\r\n  font-size: 0.8125rem;\r\n  color: var(--text-muted);\r\n  font-style: italic;\r\n}\r\n\r\n.port-empty-hint {\r\n  font-size: 0.8125rem;\r\n  color: var(--text-muted);\r\n  margin: 4px 0 0;\r\n  font-style: italic;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
